import { render, staticRenderFns } from "./MunicipiosIBGE.vue?vue&type=template&id=493505b2"
import script from "./MunicipiosIBGE.vue?vue&type=script&lang=js"
export * from "./MunicipiosIBGE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports